import SecureLS from "secure-ls"
const secureLS = new SecureLS({encodingType: "rabbit", isCompression: false, encryptionSecret: process.env.REACT_APP_NOT_SECRET_CODE})

export default secureLS